enum Scenes {
  Bootstrap = "bootstrap",
  Lobby = "lobby",
  Menu = "menu",
  Preloader = "preloader",
  Game = "game",
}

export default Scenes;
